import { pageSeo, servicesPage, websiteSettings, services, about, sectionApiData } from '@/data/content';
import { categoryItems, menuItems, topSellerItems } from '@/data/foods';
import { type PageSeo } from '@/data/content';

export const SECTION_ENDPOINTS = {
    header: '/api/sections/header',
    footer: '/api/sections/footer',
    hero: '/api/sections/hero',
    topSellers: '/api/sections/top-sellers',
    service: '/api/sections/service',
    servicesPage: '/api/sections/services-page',
    comment: '/api/sections/comment',
    menu: '/api/sections/menu',
    contact: '/api/sections/contact',
    deliveryRules: '/api/sections/delivery-rules',
    storeSettings: '/api/sections/store-settings',
    pageStructure: '/api/sections/page-structure',
    pageContent: '/api/sections/page-content',
    about: '/api/sections/about',
};

const sectionApi = {
    getSection: async (endpoint: string) => {
        switch (endpoint) {
            case SECTION_ENDPOINTS.about:
                return about || {};
            case SECTION_ENDPOINTS.servicesPage:
                return {
                    title: servicesPage.desktop_title,
                    subtitle: servicesPage.desktop_subtitle,
                    services: services || [],
                };
            case SECTION_ENDPOINTS.topSellers:
                return topSellerItems || [];
            case SECTION_ENDPOINTS.menu:
                return { categories: categoryItems, foods: menuItems };
            case SECTION_ENDPOINTS.storeSettings:
                return websiteSettings || {};
            case SECTION_ENDPOINTS.contact:
            case SECTION_ENDPOINTS.deliveryRules:
            case SECTION_ENDPOINTS.header:
            case SECTION_ENDPOINTS.footer:
                return websiteSettings || {};
            default:
                return {};
        }
    },
    getSeo: async (page: string, _template?: string) => {
        const defaultSeo = {
            meta_title: websiteSettings.restaurant_name,
            meta_description: websiteSettings.delivery_information || sectionApiData?.default_description,
        };

        if (!pageSeo) return defaultSeo;

        const seoPage = pageSeo.find((p: PageSeo) => p.slug === (page || 'home'));
        return seoPage || defaultSeo;
    },
};

export default sectionApi;
